import React from 'react';
import { useCountdown } from '../../hooks/useCountdown';
import styles from './CountdownTimer.module.css';

const TIER_COLORS = {
  green:  'var(--color-free)',
  orange: 'var(--color-warning)',
  red:    '#EF4444',
};

function pad(n) {
  return String(n).padStart(2, '0');
}

function CountdownTimer({ availableUntil, platform, type }) {
  const { days, hours, minutes, seconds, colorTier, isExpired } = useCountdown(availableUntil);

  if (!availableUntil) {
    // Tailor the message by platform
    if (platform === 'steam') {
      return (
        <div className={styles.limitedOffer}>
          <span className={styles.limitedDot} />
          Expiring soon · Check Steam for exact date
        </div>
      );
    }
    if (platform === 'itchio') {
      return (
        <div className={styles.limitedOffer}>
          <span className={styles.limitedDot} />
          Limited availability · May expire anytime
        </div>
      );
    }
    return (
      <div className={styles.limitedOffer}>
        <span className={styles.limitedDot} />
        Limited time · Check store for details
      </div>
    );
  }

  if (isExpired) {
    return <div className={styles.expired}>Expired</div>;
  }

  const color = TIER_COLORS[colorTier] || 'var(--color-free)';

  return (
    <div className={styles.timer}>
      <span className={styles.label}>Ends in</span>
      <div className={styles.segments}>
        <div className={styles.segment} style={{ borderColor: color + '66' }}>
          <span className={styles.value} style={{ color }}>{pad(days)}</span>
          <span className={styles.unit}>DAYS</span>
        </div>
        <span className={styles.colon} style={{ color }}>:</span>
        <div className={styles.segment} style={{ borderColor: color + '66' }}>
          <span className={styles.value} style={{ color }}>{pad(hours)}</span>
          <span className={styles.unit}>HRS</span>
        </div>
        <span className={styles.colon} style={{ color }}>:</span>
        <div className={styles.segment} style={{ borderColor: color + '66' }}>
          <span className={styles.value} style={{ color }}>{pad(minutes)}</span>
          <span className={styles.unit}>MIN</span>
        </div>
        <span className={styles.colon} style={{ color }}>:</span>
        <div className={styles.segment} style={{ borderColor: color + '66' }}>
          <span className={styles.value} style={{ color }}>{pad(seconds)}</span>
          <span className={styles.unit}>SEC</span>
        </div>
      </div>
    </div>
  );
}

export default CountdownTimer;
